<template>
	<div>
		<v-card-title class="mt-4">
			<h2>Moje indywidualne opinie członka zespołu</h2>
		</v-card-title>
		<agency-project-substantive-evaluation-table/>
	</div>
</template>

<script>
	import AgencyProjectSubstantiveEvaluationTable from "./AgencyProjectSubstantiveEvaluationTable";

	export default {
		name: "AgencyProjectSubstantiveEvaluationList",
		components: {AgencyProjectSubstantiveEvaluationTable},
	};
</script>

<style scoped>

</style>
